import { render, staticRenderFns } from "./PerfilPublicoView.vue?vue&type=template&id=7382f7c3&"
import script from "./PerfilPublicoView.vue?vue&type=script&lang=ts&"
export * from "./PerfilPublicoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports